import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import Moment from "react-moment";
import Placeholder from "../assets/images/placeholder.jpg"
import AuthorBox from "./Author";

function ShortBlog(props) {
  const { post } = props;
  const navigate = useNavigate();
  const showBlog = () => {
    navigate(`/blogs/${post.category}/${post.alias}`);
  };
  const thumbnail = post.fields.images && post.fields.images.thumbnail ? `data:image/jpg;base64, ${post.fields.images.thumbnail}`:Placeholder;
  const photo = post.fields.images && post.fields.images.author ? `data:image/jpg;base64, ${post.fields.images.author}`:"";
  return (
    <ShortBlogWrapper onClick={showBlog}>
      <Thumbnail>
        <img src={thumbnail} alt="" />
      </Thumbnail>
      <Content>
        <ContentInner>
          {post.category && <Category>{post.category}</Category>}
          <Title>{post.title}</Title>
          <PublicationDate>
            <Moment format="MMMM D, YYYY">{post.modifiedWhen}</Moment>
          </PublicationDate>
        </ContentInner>
        <ButtonWrap>
          <AuthorBox name={post.createdBy} photo={photo} />
          {/* <Link to={`/blogs/${post.category}/${post.alias}`}>
            <Button>Read more</Button>
          </Link> */}
        </ButtonWrap>
      </Content>
    </ShortBlogWrapper>
  );
}

export default ShortBlog;

const Category = styled.p`
  font-size: 13px;
  color: #aaa;
`;

const ShortBlogWrapper = styled.section`
cursor:pointer;
  background: #f4f4f4;
  min-width: 380px;
  max-width: 380px;
  border-radius: 4px;
  overflow: hidden;
  transition: box-shadow 0.3s ease-in-out;
  &:hover {
    box-shadow: 0px 8px 16px 0px rgba(153, 153, 153, 0.6);
  }
  @media (max-width: 1240px) {
    width: 380px;
    min-width: auto;
  }
  @media (max-width: 1198px) {
    flex-grow: 1;
    min-width: auto;
    max-width: 100%;
  }
  @media (max-width: 1000px) {
    width: 100%;
    min-width: auto;
  }
`;

export const Button = styled.button`
  border: none;
  background: none;
  border-radius: 20px;
  height: 30px;
  width: 100px;
  color: rgb(4, 115, 234);
  cursor: pointer;
  &:hover {
    background: rgb(4, 115, 234);
    color: #fff;
    transition: all 0.5s ease-in;
  }
`;
const PublicationDate = styled.p`
  font-size: 13px;
  padding-bottom: 20px;
  color: #aaa;
`;

const Title = styled.h3`
  font-size: 22px;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 28px;
  height: 70px;
`;

export const ButtonWrap = styled.section`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  align-items: center;
`;
const Thumbnail = styled.section`
  img {
    width: 380px;
    height: 180px;
    @media (max-width: 1240px) {
      width: auto;
    }
    @media (max-width: 1198px) {
      width: 100%;
      height: auto;
    }
  }
`;
const Content = styled.section`
  padding: 20px;
`;
const ContentInner = styled.section`
  height: 90px;
  margin-bottom: 10px;
`;